/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConsumerWebhookHeadersInner
 */
export interface ConsumerWebhookHeadersInner {
    /**
     * 
     * @type {string}
     * @memberof ConsumerWebhookHeadersInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ConsumerWebhookHeadersInner
     */
    value: string;
}

/**
 * Check if a given object implements the ConsumerWebhookHeadersInner interface.
 */
export function instanceOfConsumerWebhookHeadersInner(value: object): value is ConsumerWebhookHeadersInner {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function ConsumerWebhookHeadersInnerFromJSON(json: any): ConsumerWebhookHeadersInner {
    return ConsumerWebhookHeadersInnerFromJSONTyped(json, false);
}

export function ConsumerWebhookHeadersInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConsumerWebhookHeadersInner {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': json['value'],
    };
}

export function ConsumerWebhookHeadersInnerToJSON(json: any): ConsumerWebhookHeadersInner {
    return ConsumerWebhookHeadersInnerToJSONTyped(json, false);
}

export function ConsumerWebhookHeadersInnerToJSONTyped(value?: ConsumerWebhookHeadersInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'value': value['value'],
    };
}

